import React, { Component } from 'react';
import moment from 'moment';
import { Grid, Col, Row } from 'react-flexbox-grid';
import { Result } from 'antd';
import { db } from '../../../config/Fire';
import LoadingPage from '../../../components/LoadingPage';
import * as Constants from '../../../constants/nodes_database';
import * as ConstantsReserve from '../../../constants/reserve';
import SelectDateWithCalendar from '../../../components/calendar/SelectDateWithCalendar';
import ReservationsByRestoTableAdmin from '../../../components/tables/ReservationsByRestoTableAdmin';
import './styles.css';

class AnalyticalReservationsPerDayAdmin extends Component {
    state = {
        isInfoLoaded: false,
        dateSelected: moment(new Date()).format('DD/MM/YYYY'),
        data: null,
    }

    onDateSelected = (date) => {
        var dateString = moment(date).format('DD/MM/YYYY');
        this.setState({ dateSelected: dateString, isInfoLoaded: false, data: null });
    };

    /*
    renderInfo = (dateSelected) => {
        var todayReservationsAccepted = {};
        var todayReservationsPending = {};
        var restaurants = {};
        db.ref(`${Constants.RESERVATIONS}`).orderByChild("date").equalTo(dateSelected).once("value")
        .then((reserveSnap) => {
            if(reserveSnap.exists()) {
                reserveSnap.forEach((reservationSnap) => {
                    var reservation = reservationSnap.val();
                    if(reservation.state === ConstantsReserve.RESERVE_STATE.accepted) {
                        todayReservationsAccepted[reservation.reservationId] = reservation;
                        restaurants[reservation.restoId] = null;
                    } else if(reservation.state === ConstantsReserve.RESERVE_STATE.pending) {
                        todayReservationsPending[reservation.reservationId] = reservation;
                        restaurants[reservation.restoId] = null;
                    }
                });

                var keysRestaurants = Object.keys(restaurants);
                keysRestaurants.forEach((keyResto, index) => {
                    if(restaurants[keyResto] === null) {
                        db.ref(`${Constants.RESTAURANTS}/${keyResto}`).once("value")
                        .then((restoSnap) => {
                            if(restoSnap.exists()) {
                                restaurants[keyResto] = restoSnap.val();
                            }
                            if((index + 1) === keysRestaurants.length) {
                                this.setState({ isInfoLoaded: true, todayReservationsAccepted, todayReservationsPending, restaurants });
                            }
                        })
                        .catch((err) => {

                        })
                    } else {
                        if((index + 1) === keysRestaurants.length) {
                            this.setState({ isInfoLoaded: true, todayReservationsAccepted, todayReservationsPending, restaurants });
                        }
                    }
                });
                if(keysRestaurants.length === 0) {
                    this.setState({ isInfoLoaded: true });
                }
            } else {
                this.setState({ isInfoLoaded: true });
            }
        })
        .catch((err) => {

        });
    }

    renderChart = () => {
        const { restaurants, todayReservationsAccepted, todayReservationsPending } = this.state;
        if(todayReservationsAccepted || todayReservationsPending) {
            const countReservationsAcceptedByResto = {};
            const countReservationsPendingByResto = {};
        
            if(todayReservationsAccepted) {
                var keysTodayReservationsAccepted = Object.keys(todayReservationsAccepted);
                keysTodayReservationsAccepted.forEach(keyTodayReservationAccepted => {
                    if(countReservationsAcceptedByResto[todayReservationsAccepted[keyTodayReservationAccepted].restoId]) {
                        countReservationsAcceptedByResto[todayReservationsAccepted[keyTodayReservationAccepted].restoId] += 1;
                    } else {
                        countReservationsAcceptedByResto[todayReservationsAccepted[keyTodayReservationAccepted].restoId] = 1;
                    }
                });
            }

            if(todayReservationsPending) {
                var keysTodayReservationsPending = Object.keys(todayReservationsPending);
                keysTodayReservationsPending.forEach(keyTodayReservationPending => {
                    if(countReservationsPendingByResto[todayReservationsPending[keyTodayReservationPending].restoId]) {
                        countReservationsPendingByResto[todayReservationsPending[keyTodayReservationPending].restoId] += 1;
                    } else {
                        countReservationsPendingByResto[todayReservationsPending[keyTodayReservationPending].restoId] = 1;
                    }
                });
            }
    
            // const data = {
            //     labels: ['a', 'b', 'c', 'd', 'e'],
            //     datasets: [
            //       {
            //         stack: 'stack1',
            //         label: 'data1',
            //         data: [1, 2, 3, 4, 5]
            //       },
            //       {
            //         stack: 'stack1',
            //         label: 'data2',
            //         data: [5, 4, 3, 2, 1]   
            //       }
            //     ]
            // }
            var keysRestaurants = Object.keys(restaurants);
            const labels = [];
            const dataCountAccepted = [];
            const dataCountPending = [];
            keysRestaurants.forEach(keyRestaurant => {
                labels.push(restaurants[keyRestaurant].name);
                if(countReservationsAcceptedByResto[keyRestaurant]) {
                    dataCountAccepted.push(countReservationsAcceptedByResto[keyRestaurant]);
                } else {
                    dataCountAccepted.push(0);
                }
                if(countReservationsPendingByResto[keyRestaurant]) {
                    dataCountPending.push(countReservationsPendingByResto[keyRestaurant]);
                } else {
                    dataCountPending.push(0);
                }
            });

            const data = {
                labels: labels,
                datasets: [
                  {
                    stack: 'stack1',
                    backgroundColor: 'rgb(112, 120, 184)',
                    borderColor: 'rgb(148, 80, 155)',
                    label: 'Cantidad de reservas aceptadas',
                    data: dataCountAccepted,
                  },
                  {
                    stack: 'stack2',
                    backgroundColor: 'rgb(148, 80, 155)',
                    borderColor: 'rgb(112, 120, 184)',
                    label: 'Cantidad de reservas pendientes',
                    data: dataCountPending,
                  }
                ]
            }
            const options = {
                maintainAspectRatio: false,
                tooltips: {
                    mode: 'x-axis'
                },
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true,
                            callback: function(value) {if (value % 1 === 0) {return value;}}
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        barPercentage: 0.4
                    }]
                }
              }
            return <Bar className="barCont" data={data} options={options} width={100} height={100} />
        } else {
            return <Result
            status="warning"
            title="No hay reservas para la fecha indicada." />
        }
    }
    */

    renderReservationsByDate = dateSelected => {
        var todayReservationsMap = {};
        db.ref(`${Constants.RESERVATIONS}`).orderByChild("date").equalTo(dateSelected).once("value")
        .then((reserveSnap) => {
            if(reserveSnap.exists()) {
                reserveSnap.forEach((reservationSnap) => {
                    var reservation = reservationSnap.val();
                    if(todayReservationsMap[reservation.restoId] !== undefined) {
                        todayReservationsMap[reservation.restoId]['restoName'] = reservation.restoName;
                        todayReservationsMap[reservation.restoId]['reservationCount'] = todayReservationsMap[reservation.restoId]['reservationCount'] + 1;
                        todayReservationsMap[reservation.restoId]['peopleTotalCount'] = todayReservationsMap[reservation.restoId]['peopleTotalCount'] + reservation.peopleCount;
                        todayReservationsMap[reservation.restoId][reservation.state] = todayReservationsMap[reservation.restoId][reservation.state] + 1;
                    } else {
                        todayReservationsMap[reservation.restoId] = {
                            'restoName': reservation.restoName,
                            'reservationCount': 1,
                            'peopleTotalCount': reservation.peopleCount,
                            [ConstantsReserve.RESERVE_STATE.accepted]: 0,
                            [ConstantsReserve.RESERVE_STATE.pending]: 0,
                            [ConstantsReserve.RESERVE_STATE.cancelled]: 0,
                            [ConstantsReserve.RESERVE_STATE.rejected]: 0,
                            [ConstantsReserve.RESERVE_STATE.assisted]: 0,
                            [ConstantsReserve.RESERVE_STATE.no_assisted]: 0,
                        }
                        todayReservationsMap[reservation.restoId][reservation.state] = todayReservationsMap[reservation.restoId][reservation.state] + 1;
                    }
                });
                var data = [];
                var keysTodayReservationsMap = Object.keys(todayReservationsMap);
                keysTodayReservationsMap.forEach((keyResto, index) => {
                    data.push({ id: keyResto, ...todayReservationsMap[keyResto] });
                });
                this.setState({ isInfoLoaded: true, data });
            } else {
                this.setState({ isInfoLoaded: true });
            }
        })
        .catch((err) => {

        });
    }
    
    render() {
        return (
            <div>
                {
                    this.state.isInfoLoaded ?
                        <div>
                            {
                                <Grid className="analyticalReservationsPerDayAdminCont">
                                    <Row className="reservationsCont">
                                        <Col xs={12} md={3}>
                                            <SelectDateWithCalendar dateSelected={this.state.dateSelected} onSelected={this.onDateSelected} disabledBeforeTodayDate={false} />
                                        </Col>
                                        <Col xs={12} md={9}>
                                        {
                                                this.state.data ?
                                                    <ReservationsByRestoTableAdmin data={this.state.data} />
                                                    :
                                                    <Result
                                                    status="warning"
                                                    title="No hay reservas para la fecha indicada." />
                                        }
                                        </Col>
                                    </Row>
                                </Grid>
                            }
                        </div>
                        :
                        <div>
                            <LoadingPage />
                            {this.renderReservationsByDate(this.state.dateSelected)}
                        </div>
                }
            </div>
        );
    }
}

AnalyticalReservationsPerDayAdmin.propTypes = {

};

export default AnalyticalReservationsPerDayAdmin;